import React, { useState, useEffect } from 'react';
import Tabs, { Tab } from 'src/components/Tabs';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  Page,
  Label,
  LinkLabel,
  Row,
  Icon,
  Column,
  LineSeparator,
} from 'src/components/Layout';
import { SearchableDropdown } from 'src/components/SearchableDropdown';
import {
  dateStrWithHourMinutesToNorwegianDateFormat,
  incrementWeek,
} from 'src/utils/date.utils';
import { useDispatch, useSelector } from 'react-redux';
import { DateDropdownItem } from 'src/components/DateDropdownItem';
import { enrollmentActions } from 'src/store/enrollment/enrollment.actions';
import {
  getRegisteredEnrolments,
  getRegisteredEnrolmentsDates,
} from 'src/store/enrollment/enrollment.selectors';
import LoadingIndicator from 'src/components/LoadingIndicator';
import styled, { css } from 'styled-components';
import { faComment } from '@fortawesome/free-regular-svg-icons';
import Modal from 'src/components/Modal';
import Button from 'src/components/Button';
import { useToast } from 'src/components/Toast';
import { getBrandingText, getBrandingColor, colorTypes } from 'src/branding';
import { Breadcrumbs } from 'src/components/Breadcrumbs';
import { getFeaturesEnabled, getSlaughterDeletionnDeadline } from 'src/slaughterhouseSpecific';
import { capitalize, flatArray } from 'src/utils/misc.utils';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons/index';
import axiosInstance from 'src/axios-instance';
import { backendUrl } from '../../config';
import {
  AnimalRowCheckmark, AnimalRowFieldName, RegisteredReturnFormWrapper, ReturnFormWrapper,
} from './Components';
import { routes } from '../routes.manifest';
import { AnimalGroupHeader, AnimalGroupToggleIcon, AnimalGroupTopPart } from '../Accountings/Components';
import { ReturnForm } from './ReturnForm/ReturnForm';

const AnimalRows = styled.div`
  margin-top: 4em;
  padding-top: 1em;
  padding-bottom: 1em;
  background-color: ${getBrandingColor(colorTypes.whiteAltBg)};
`;
const AnimalRowField = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 1em;
`;

const AnimalRow = styled.div`
  flex-wrap: nowrap;
  @media screen and (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

const RegisteredEnrolmentsPage = styled(Page)`
  width: 100%;
  @media screen and (max-width: 900px) {
    width: fit-content;
  }
`;

const CommentLabel = styled(Label)`
  position: relative;
  background-color: rgb(244, 241, 236);
  padding: 2em;
  max-width: 320px;
  white-space: pre-line;
  width: 70%;

  :after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 0.5em solid transparent;
    border-right-color: rgb(244, 241, 236);
    border-left: 0;
    margin-top: -0.5em;
    margin-left: -0.5em;
  }
`;

const AnimalNameLabelCont = styled(Label)`
  align-self: center;
  padding-left: 0;
  padding-right: 1.5em;
  width: 17em;

  @media screen and (max-width: 500px) {
    padding-right: 1em;
  }
`;

const AnimalRowDetails = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1.1em;
  padding-bottom: 1.1em;
  padding-left: 0;
  padding-right: 2.5em;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;

  [name='sheepInfo'] {
    position: relative;
    top: 0.55em;
  }

  @media screen and (max-width: 1000px) {
    padding-left: 0;

    [name='sheepInfo'] {
      top: 0;
    }
    [name='pickup'] {
      flex-direction: column;
    }
  }

  @media screen and (max-width: 500px) {
    padding-top: 0.5em;
  }
`;

const DeleteBtn = styled(LinkLabel)`
  :hover {
    cursor: ${({ deleteNotPossible }) => (deleteNotPossible ? 'not-allowed' : 'pointer')};
  }
`;

const RegisteredSlaughters = ({
  location: { pathname },
  history: { push },
}) => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [
    animalRowShowCommentForRowNo,
    setAnimalRowShowCommentForRowNo,
  ] = useState(-1);

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [isReturnFormDataExpanded, setIsReturnFormDataExpanded] = useState(false);
  const dispatch = useDispatch();
  const enrolmentDates = useSelector(getRegisteredEnrolmentsDates);
  const enrolments = useSelector(getRegisteredEnrolments);
  console.info('enrolments', enrolments);

  const toast = useToast();

  const enrolmentKindToNorwegian = (kind) => {
    if (kind === 'slaughter') {
      return ' - Slakt';
    } else if (kind.includes('buy')) {
      return ' - Kjøp';
    } else if (kind.includes('sell')) {
      return ' - Salg';
    }
  };

  const sheepKindToNowegian = (kind) => {
    const kl = kind.toLowerCase();
    if (kl === 'lamb') {
      return 'Lam';
    }
    if (kl === 'sheep') {
      return 'Sau';
    }
    if (kl === 'vaer') {
      return 'Vær';
    }
  };

  useEffect(() => {
    if (
      !enrolmentDates.registeredEnrolmentsDates
      && !enrolmentDates.isFetching
      && !enrolmentDates.error
    ) {
      dispatch(enrollmentActions.fetchRegisteredEnrolmentDates());
    }
  }, [
    dispatch,
    enrolmentDates.error,
    enrolmentDates.isFetching,
    enrolmentDates.registeredEnrolmentsDates,
  ]);

  useEffect(() => {
    axiosInstance.request({
      method: 'POST',
      url: `${backendUrl}/api/markread/enrolment/notification`,
      withCredentials: true,
    });
  }, []);

  // set and fetch first enrolment default selected enrolment(first)
  useEffect(() => {
    if (
      !enrolmentDates.isFetching
      && !enrolmentDates.error
      && enrolmentDates.registeredEnrolmentsDates
      && enrolmentDates.registeredEnrolmentsDates.length > 0
    ) {
      setSelectedDate(enrolmentDates.registeredEnrolmentsDates[0]);
      dispatch(
        enrollmentActions.fetchRegisteredEnrolment({
          date: enrolmentDates.registeredEnrolmentsDates[0].date,
          kind: enrolmentDates.registeredEnrolmentsDates[0].kind,
        }),
      );
    }
  }, [dispatch, enrolmentDates]);

  const selectedEnrolment = enrolments.registeredEnrolments && selectedDate
    ? enrolments.registeredEnrolments[selectedDate.date]
    : null;

  const returnFormData = getFeaturesEnabled().return_form && selectedEnrolment?.return_form_data;

  const groupIdReturnSkin = 1; // this will never be choosed as an other group id
  const returnFormRecceiptReturnSkinGroup = {
    customHeader: 'Returhud og returskinn', formData: {}, id: groupIdReturnSkin, hideFields: true,
  };
  const getAnimalRowsForReturnFormRecceipt = () => {
    if (!returnFormData) {
      return [];
    }
    const rowsWithReturn = returnFormData && flatArray(returnFormData.animal_rows.map((r) => (returnFormData.animal_category === 'sheep' ? r.return_skin_meat : [r]))).filter((row) => row.return_skin || row.return_meat);

    // also add animals with return skin to own group
    return rowsWithReturn.map(
      (r) => (r.return_skin ? { ...r, return_options_groups: [...(r.return_options_groups || []), { group_id: groupIdReturnSkin, amount_animals: 1 }] } : r),
    );
  };

  const getIsBuySell = () => selectedEnrolment.kind.includes('sell')
    || selectedEnrolment.kind.includes('buy');

  const onDeleteEnrolment = () => {
    dispatch(
      enrollmentActions.deleteRegisteredEnrolment({
        date: selectedDate.date,
        kind: selectedDate.kind,
        onSuccess: () => {
          setSelectedDate(null);
          dispatch(enrollmentActions.fetchRegisteredEnrolmentDates());
          setIsReturnFormDataExpanded(false);
          toast.addMessage(
            getIsBuySell()
              ? 'Forespørsel om sletting ble sendt og innmeldingen vil etterhvert bli slettet.'
              : 'Innmeldingen ble slettet',
            getIsBuySell() ? 5000 : 2500,
          );
        },
        onError: () => {
          toast.addError('Kunne ikke slette innmeldingen');
        },
      }),
    );
  };

  const getCommentForReturnFormRecceipt = () => {
    if (!returnFormData) {
      return '';
    }
    let c = '';
    const newline = '\r\n';
    if (returnFormData.returnSlaughterOptionsCommentMeat) {
      c += `Returkjøtt:${newline}${returnFormData.returnSlaughterOptionsCommentMeat}${newline}${newline}`;
    }
    if (returnFormData.returnSlaughterOptionsCommentSkin) {
      c += `Returhud og returskinn:${newline}${returnFormData.returnSlaughterOptionsCommentSkin}`;
    }
    return c;
  };

  const deleteEnrolmentNotPossible = () => {
    const deadlineForSlaughterhouse = getSlaughterDeletionnDeadline();

    const momentDeadline = moment()
      .week(selectedEnrolment.animal_rows[0].delivery_week)
      .year(selectedEnrolment.animal_rows[0].delivery_year)
      .isoWeekday(deadlineForSlaughterhouse.weekday) // stats at monday=1
      .set({ hour: deadlineForSlaughterhouse.hour, minute: deadlineForSlaughterhouse.minute, second: '0' });

    const [year1, week1] = incrementWeek(moment().year(), moment().week());
    const now = moment()
      .week(week1)
      .year(year1);
    const invalid = now.isAfter(momentDeadline);
    return invalid;
  };

  const removeSWComments = (str) => {
    if (!str) {
      return '';
    }
    return str.replace(/\$[^\$]*\$(\n)?/g, '');
  };

  return (
    <RegisteredEnrolmentsPage
      title="Innsendte innmeldinger"
      style={{
        paddingBottom: '5em',
        alignSelf: 'center',
        maxWidth: '645px',
        minWidth: '45%',
        width: '90%',
      }}
    >

      <Breadcrumbs
        breadcrumbs={[{ title: 'Innsendte innmeldinger', url: '/registered-enrolments' }]}
        wrapperStyle={css`
            margin-bottom: 1.5rem; `}
      />
      {showDeleteConfirmation && (
        <Modal>
          <Label size="1.15em" padding="1.5em">
            Er du sikker på at du vil
            {' '}
            {getIsBuySell()
              ? 'sende forespørsel om sletting av innmeldingen'
              : 'slette innmeldingen'}
            ?
          </Label>

          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              fontSize: '1.15em',
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Button
              secondary
              style={{
                padding: '12px 41px',
              }}
              onClick={() => setShowDeleteConfirmation(false)}
            >
              Nei
            </Button>
            <Button
              style={{
                marginLeft: '1em',
                padding: '12px 41px',
              }}
              warn
              onClick={() => {
                setShowDeleteConfirmation(false);
                onDeleteEnrolment();
              }}
            >
              Ja,
              {' '}
              {getIsBuySell()
                ? 'send forespørsel om sletting'
                : 'slett innmeldingen'}
            </Button>
          </div>
        </Modal>
      )}
      <Label
        font="serif"
        as="h1"
        size="2.5em"
        color="#68696d"
        marginBottom="0.5em"
      >
        Innsendte innmeldinger
      </Label>
      <Tabs
        value={pathname}
        onChange={(tab) => push(tab)}
        style={{ maxHeight: '3.2em' }}
      >
        <Tab value={routes.registerEnrolment}>Ny</Tab>
        <Tab value={routes.registeredEnrolments}>Innsendte</Tab>
      </Tabs>

      {enrolmentDates.registeredEnrolmentsDates
        && enrolmentDates.registeredEnrolmentsDates.length === 0 && (
          <Label size="1.5em" marginTop="0.5em">
            Fant ingen registrerte innmeldinger.
          </Label>
      )}

      {enrolmentDates.error && (
        <Label size="1.5em" marginTop="0.5em">
          Kunne ikke hente registrerte innmeldinger.
        </Label>
      )}

      {((enrolmentDates.isFetching
        || !enrolmentDates.registeredEnrolmentsDates)
        && !enrolmentDates.error && (
          <LoadingIndicator
            withText
            style={{ position: 'absolute', top: '4em' }}
          />
      ))
        || (selectedDate && (
          <div>
            <Label
              color={getBrandingColor(colorTypes.fontHeader)}
              marginBottom="0.2rem"
              marginTop="1.5em"
            >
              Velg innmelding
            </Label>
            <SearchableDropdown
              placeholder="Søk etter dato"
              itemSearchKey="formatted"
              smallScreenwidth="90%"
              bigScreenWidth="390px"
              bigScreenWidthResultList="388px"
              smallScreenWidthResultList="97%"
              selectedItem={{
                date: selectedDate.date,
                formatted: dateStrWithHourMinutesToNorwegianDateFormat(
                  selectedDate.date,
                ),
                extra: enrolmentKindToNorwegian(selectedDate.kind),
              }}
              initialValue={
                dateStrWithHourMinutesToNorwegianDateFormat(selectedDate.date)
                + (selectedDate.date
                === enrolmentDates.registeredEnrolmentsDates[0].date
                  ? ' ( nyeste innmelding) '
                  : '')
              }
              renderSelectedItemInInput={(item) => (item.date === selectedDate.date
                ? `${item.formatted} ${
                      item.date
                      === enrolmentDates.registeredEnrolmentsDates[0].date
                        ? '(nyeste innmelding)'
                        : ''
                    }`
                : item.formatted)}
              renderItem={(item, searchTerm, itemHasFocus) => (
                <DateDropdownItem
                  key={searchTerm}
                  searchTerm={searchTerm}
                  itemHasFocus={itemHasFocus}
                  item={item}
                />
              )}
              dataitems={enrolmentDates.registeredEnrolmentsDates.map((d) => ({
                date: d.date,
                extra: enrolmentKindToNorwegian(d.kind),
                formatted: dateStrWithHourMinutesToNorwegianDateFormat(
                  d.date,
                ),
                kind: d.kind,
              }))}
              onSelectedChange={(item) => {
                if (item) {
                  setSelectedDate(item);
                  setIsReturnFormDataExpanded(false);
                  dispatch(
                    enrollmentActions.fetchRegisteredEnrolment({
                      date: item.date,
                      kind: item.kind,
                    }),
                  );
                }
              }}
            />

            {enrolments.error && (
              <Label size="1.5em" marginTop="0.6em">
                Kunne ikke hente denne innmeldingen.
              </Label>
            )}

            {enrolments.isFetching && (
              <Label size="1.1em" marginTop="0.6em">
                Laster...
              </Label>
            )}
            {!enrolments.isFetching && selectedEnrolment && (
              <div
                style={{
                  marginTop: '1.5em',
                }}
              >
                <Label bold size="1.3em" marginBottom="1em">
                  Innmelding
                  {enrolmentKindToNorwegian(selectedEnrolment.kind)}
                </Label>
                {selectedEnrolment.kind === 'slaughter' && (
                  <div
                    style={{
                      backgroundColor: 'rgba(230, 227, 224, 0.27)',
                      padding: '1.5em',
                    }}
                  >
                    {(selectedEnrolment.pickup_completed && (
                      <Label>
                        <span
                          style={{ fontWeight: 'bold', fontSize: '1.25em' }}
                        >
                          Status:
                          {' '}
                        </span>
                        Henting på innmelding er gjennomført
                      </Label>
                    )) || (
                      <Label>
                        <span
                          style={{ fontWeight: 'bold', fontSize: '1.25em' }}
                        >
                          Status:
                          {' '}
                        </span>
                        Et eller flere dyr venter på henting. Se oversikten
                        nedenfor for detaljer.
                      </Label>
                    )}
                  </div>
                )}
                {!getIsBuySell() && (
                  <DeleteBtn
                    style={{
                      color: deleteEnrolmentNotPossible()
                        ? getBrandingColor(colorTypes.linkDisabled)
                        : getBrandingColor(colorTypes.error),
                      textDecoration: 'underline',
                      display: 'block',
                      fontSize: '0.92em',
                      marginTop: '1.2em',
                    }}
                    deleteNotPossible={deleteEnrolmentNotPossible()}
                    onClick={() => {
                      if (!deleteEnrolmentNotPossible()) {
                        setShowDeleteConfirmation(true);
                      }
                    }}
                  >
                    {getIsBuySell()
                      ? 'Send forespørsel om sletting'
                      : 'Slett innmeldingen'}
                  </DeleteBtn>
                )}
                {!getIsBuySell() && deleteEnrolmentNotPossible() && (
                  <Label
                    color={getBrandingColor(colorTypes.fontHeader)}
                    style={{
                      fontSize: '0.9em',
                    }}
                  >
                    Fristen for sletting av innmeldinger har gått ut. Ta
                    eventuelt kontakt med
                    {' '}
                    {getBrandingText('companyName')}
                    {' '}
                    for endringer.
                  </Label>
                )}
                {getIsBuySell() && (
                  <Label
                    color={getBrandingColor(colorTypes.fontHeader)}
                    style={{ fontSize: '0.9em' }}
                  >
                    Ta kontakt med
                    {' '}
                    {getBrandingText('companyName')}
                    {' '}
                    dersom du ønsker å slette
                    innmeldingen.
                  </Label>
                )}
                <AnimalRows>
                  {selectedEnrolment.animal_rows.map((a, index) => (
                    <>
                      <AnimalRow
                        name="animalRow"
                        style={{
                          display: 'flex',
                          paddingLeft: '1.5em',
                          paddingRight: '1.5em',
                        }}
                      >
                        {selectedEnrolment.kind === 'slaughter' && (
                          <AnimalNameLabelCont>
                            <Label bold size="1.3em">
                              {a.product_text}
                            </Label>
                          </AnimalNameLabelCont>
                        )}
                        {/* this is only relevant for slaughter, since in sell rows `a.is_cattle` is spelled `a.is_catle` */}
                        {a.is_cattle && !a.product_text && (
                          <AnimalNameLabelCont>
                            <Label bold size="1.3em">
                              Storfe
                            </Label>
                          </AnimalNameLabelCont>
                        )}

                        {selectedEnrolment.kind !== 'slaughter'
                          && selectedEnrolment.kind.includes('sheep') && (
                            <AnimalNameLabelCont name="sheepInfo">
                              <Label bold size="1.3em">
                                {a.race_name}
                              </Label>
                              <Label>{sheepKindToNowegian(a.kind)}</Label>
                            </AnimalNameLabelCont>
                        )}

                        {selectedEnrolment.kind === 'buy_cattle' && (
                          <AnimalNameLabelCont
                            name="buyCattleInfo"
                            style={{ width: '110px' }}
                          >
                            <Label bold size="1.3em">
                              Storfe
                            </Label>
                            <Label marginRight="1.5em">
                              {a.kind.live_animal_kind}
                            </Label>
                          </AnimalNameLabelCont>
                        )}

                        {selectedEnrolment.kind === 'buy_cattle' && (
                          <AnimalNameLabelCont
                            name="buyCattleDesc"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Label>{a.kind.desc}</Label>
                          </AnimalNameLabelCont>
                        )}

                        {selectedEnrolment.kind !== 'slaughter'
                          && selectedEnrolment.kind.includes('pigs') && (
                            <AnimalNameLabelCont>
                              <Label bold size="1.3em" style={{ width: '9em' }}>
                                {`Smågris${a.is_vak ? ' Vak ' : ''}${
                                  a.is_spf ? ' Spf ' : ''
                                }`}
                              </Label>
                            </AnimalNameLabelCont>
                        )}
                        {selectedEnrolment.kind === 'sell_cattle' && (
                          <AnimalNameLabelCont>
                            <Label bold size="1.3em" style={{ width: '9em' }}>
                              {!a?.product_text || a.product_text === 'ukjent' ? 'Storfe' : capitalize(a.product_text)}
                            </Label>
                          </AnimalNameLabelCont>
                        )}
                        <AnimalRowDetails key={index}>
                          {selectedEnrolment.kind !== 'sell_cattle' && (
                            <AnimalRowField>
                              <AnimalRowFieldName>Antall:</AnimalRowFieldName>
                              <Label inline>{a.amount}</Label>
                            </AnimalRowField>
                          )}

                          {(selectedEnrolment.kind === 'slaughter'
                              && (a.product_text.toLowerCase().includes('gris') || (
                                (a.product_text.toLowerCase().includes('purke')
                                  || a.product_text.toLowerCase().includes('råne'))
                                  && !getFeaturesEnabled().purke_raane_individual_registration
                              ))
                              && (
                                <AnimalRowField>
                                  <AnimalRowFieldName>
                                    Klubbenummer:
                                  </AnimalRowFieldName>
                                  <Label>{a.club_no}</Label>
                                </AnimalRowField>
                              ))
                            || (a.is_cattle && a.animal_id && (
                              <AnimalRowField>
                                <AnimalRowFieldName
                                  style={{ whiteSpace: 'nowrap' }}
                                >
                                  Merkenr / Individnr:
                                </AnimalRowFieldName>
                                <Label>{a.animal_id}</Label>
                              </AnimalRowField>
                            ))
                            || (((a.product_text
                              && a.product_text.toLowerCase().includes('purke'))
                              || (a.product_text
                                && a.product_text
                                  .toLowerCase()
                                  .includes('råne')))
                                && getFeaturesEnabled().purke_raane_individual_registration && (
                                  <AnimalRowField>
                                    <AnimalRowFieldName>Ørenr:</AnimalRowFieldName>
                                    <Label>{a.animal_id}</Label>
                                  </AnimalRowField>
                            ))
                            || (a.animal_id && (
                              <AnimalRowField>
                                <AnimalRowFieldName>
                                  Individnr:
                                </AnimalRowFieldName>
                                <Label>{a.animal_id}</Label>
                              </AnimalRowField>
                            ))}

                          {(a.pickup_completed
                            && selectedEnrolment.kind === 'slaughter' && (
                              <AnimalRowField>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                  }}
                                >
                                  <AnimalRowCheckmark style={{ left: '-0.1rem', bottom: '0.1rem' }} />
                                  <AnimalRowFieldName>
                                    Hentet
                                  </AnimalRowFieldName>
                                </div>
                              </AnimalRowField>
                          ))
                            || (selectedEnrolment.kind === 'slaughter' && (
                              <>
                                <AnimalRowField>
                                  <AnimalRowFieldName>
                                    Basisuke:
                                  </AnimalRowFieldName>
                                  <Label style={{ whiteSpace: 'nowrap' }}>
                                    {a.delivery_week}
                                  </Label>
                                </AnimalRowField>
                                <AnimalRowField>
                                  <AnimalRowFieldName>
                                    Hentetidspunkt:
                                  </AnimalRowFieldName>
                                  <Label style={{ whiteSpace: 'nowrap' }}>
                                    {a.expected_pickup_date
                                      && a.expected_pickup_date}
                                    {a.expected_pickup_time && a.expected_pickup_time !== '00:00' && ` kl ${a.expected_pickup_time}`}
                                    {!a.expected_pickup_date && (!a.expected_pickup_time || a.expected_pickup_time === '00:00') && 'Ikke satt'}
                                  </Label>
                                </AnimalRowField>
                                <AnimalRowField>
                                  <AnimalRowFieldName>
                                    Transportør:
                                  </AnimalRowFieldName>
                                  <Label style={{ whiteSpace: 'nowrap' }}>
                                    {(a.haulier && a.haulier.name)
                                      || 'Ikke satt'}
                                  </Label>
                                </AnimalRowField>
                              </>
                            ))}
                          {removeSWComments(a.comment).length > 0 && (
                            <Row marginLeft="1em">
                              <LinkLabel>
                                <Row
                                  marginLeft="0.2em"
                                  style={{
                                    fontSize: '0.85rem',
                                  }}
                                >
                                  <Icon
                                    size="1.3em"
                                    marginRight="0.4em"
                                    icon={faComment}
                                  />
                                  <Label
                                    textDecoration="underline"
                                    onClick={() => {
                                      if (animalRowShowCommentForRowNo === -1) {
                                        setAnimalRowShowCommentForRowNo(index);
                                      }
                                    }}
                                  >
                                    Kommentar
                                  </Label>

                                  {animalRowShowCommentForRowNo === index && (
                                    <Column>
                                      <Modal
                                        closable
                                        noEscape
                                        onClose={() => {
                                          setAnimalRowShowCommentForRowNo(-1);
                                        }}
                                        height="fit-content"
                                        width="80%"
                                        style={{
                                          minHeight: '12%',
                                          maxWidth: '600px',
                                        }}
                                      >
                                        <p
                                          style={{
                                            hyphens: 'auto',
                                            whiteSpace: 'pre-line',
                                          }}
                                        >
                                          {removeSWComments(a.comment)}
                                        </p>
                                      </Modal>
                                    </Column>
                                  )}
                                </Row>
                              </LinkLabel>
                            </Row>
                          )}
                        </AnimalRowDetails>
                      </AnimalRow>
                      <LineSeparator />
                    </>
                  ))}
                </AnimalRows>

                <Row marginTop="2em">
                  <Icon
                    size="3.4em"
                    marginRight="0.4em"
                    style={{ alignSelf: 'center' }}
                    icon={faComment}
                  />
                  <CommentLabel>
                    {removeSWComments(selectedEnrolment.comment) || (
                      <span style={{ fontStyle: 'italic' }}>
                        Fant ingen kommentar
                      </span>
                    )}
                  </CommentLabel>
                </Row>
                {returnFormData
                && (
                  <ReturnFormWrapper>
                    <AnimalGroupTopPart style={{ width: 'fit-content' }} onClick={() => setIsReturnFormDataExpanded((old) => !old)}>
                      <AnimalGroupHeader>Returskjema</AnimalGroupHeader>
                      <AnimalGroupToggleIcon
                        icon={
                      isReturnFormDataExpanded
                        ? faCaretUp
                        : faCaretDown
                    }
                      />
                    </AnimalGroupTopPart>
                    {isReturnFormDataExpanded
                  && (
                    <RegisteredReturnFormWrapper>
                      <ReturnForm
                        dontShowEmptyGroups
                        animalKind={returnFormData.animal_category}
                        animalRows={getAnimalRowsForReturnFormRecceipt()}
                        groupsData={returnFormData.returnSlaughterOptionsGroups.concat(returnFormRecceiptReturnSkinGroup)}
                        commonData={returnFormData.returnSlaughterOptionsCommon}
                        form={{ isFetching: false, data: { form_fields: { ...returnFormData.return_form_fields }, 'illegal-checkbox-combinations': returnFormData['return_form_illegal-checkbox-combinations'] } }}
                        comment={getCommentForReturnFormRecceipt()}
                        isReceiptMode
                        commonFieldsKinds={['meat', 'skin']}
                        header={`Kvittering - Returskjema [${dateStrWithHourMinutesToNorwegianDateFormat(selectedDate.date)}]`}
                      />
                    </RegisteredReturnFormWrapper>
                  )}
                  </ReturnFormWrapper>
                )}
              </div>
            )}
          </div>
        ))}
    </RegisteredEnrolmentsPage>
  );
};

export default withRouter(RegisteredSlaughters);
